import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  Pipe,
  PipeTransform,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  CommonState,
  PendoService,
  selectUserFlag,
} from '@patient-help-center/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import HelpCenterJson from '../shared/help-center.json';

@Component({
  selector: 'app-q-and-a',
  templateUrl: './q-and-a.component.html',
  styleUrls: ['./q-and-a.component.scss'],
})
export class QAndAComponent implements OnInit, OnDestroy {
  destroyed = new Subject();
  helpData = HelpCenterJson;
  category = this.helpData[0];
  questions = [];
  questionOne = this.category.featuredFAQ[0];
  isRegisteredUser = false;
  guestCLink =
    'https://www.labcorp.com/help/contact-info-for-patient/patient-portal-inquiry';
  RegCLink = '';

  constructor(
    private route: ActivatedRoute,
    private pendoService: PendoService,
    private commonStore: Store<CommonState>,
    private changeDet: ChangeDetectorRef,
    private router: Router
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('questionId');
    const subId = this.route.snapshot.paramMap.get('subId');
    const qId = subId ? id+'.'+subId : id;
    const cId = qId.split('.')[0];
    this.category = this.helpData.filter((e) => e.categoryId === cId)[0];
    this.questions = [];
    this.category.subCategory.forEach((item) => {
      this.questions = this.questions.concat(item.QandA);
    });
    this.questionOne = this.questions.filter((e) => e.questionId === qId)[0];
    this.pendoService.setUnknownUser();

    this.commonStore
      .select(selectUserFlag)
      .pipe(takeUntil(this.destroyed))
      .subscribe((userFlag) => {
        if (userFlag === 'r') {
          this.isRegisteredUser = true;
          this.questionOne.answer = this.questionOne.answer.replace(
            /https:\/\/www.labcorp.com\/help\/contact-info-for-patient\/patient-portal-inquiry/g,
            'https://www.labcorp.com/contact-us/labcorp-patient-portal'
          );
          this.changeDet.detectChanges();
        }
      });
  }

  getRelatedLinks(): any {
    return this.questionOne!['relatedLinks'] || [];
  }

  getRelatedLinkContent(linkId: string): string {
    const questionLink = this.questions.filter((e) => e.questionId === linkId)[0];
    return questionLink?.question || '';
  }

  goToSelectedLink(linkId: string) {
    window.location.href = document.baseURI + 'q-and-a/'+this.convertDotToSlash(linkId);
  }

  
  /**
   * Replace dots with slashes in a string.
   * @param str The input string with dots to be replaced.
   * @returns A new string with dots replaced by slashes.
   */
  convertDotToSlash(str: string): string {
    return str.replace(/\./g, '/');
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
